export default "__VITE_ASSET__C0M0cuvk__"